var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "content-wrapper" }, [
    _vm.filterRequired
      ? _c("div", { staticClass: "first-row" }, [_vm._t("filters")], 2)
      : _vm._e(),
    _c("div", { staticClass: "second-row" }, [_vm._t("content")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }